export default {
  shopTitle: 'Current Shop',
  condition: 'Query Condition',
  uploadFile: 'Upload File',
  modelTitle: 'Upload',
  typeOption: {
    code: 'CODE',
    upc: 'UPC',
  },
  button: {
    demo: 'Template',
    upload: 'Upload',
  },
  status: {
    success: 'Success',
    fail: 'Fail',
    invalid: 'Invalid',
  },
  history: {
    table: {
      date: 'Date',
      name: 'Name',
      mainShop: 'Main Shop',
      success: 'Success',
      fail: 'Fail',
      show: 'Show',
      addToFavorite: 'Add To Favorites',
      addButton: 'Add',
      detail: 'Failed SKUs',
      detailButton: 'Detail',
      upload: 'Upload Report',
      download: 'Download',
    },
    tips: {
      downloadFail: 'Download failed',
    },
  },
  historyDetail: {
    modalTitle: 'History',
    table: {
      view: 'View',
      brand: 'Brand',
      name: 'Name',
      code: 'Code',
      upc: 'UPC',
      state: 'Status',
    },
  },
  uploadHandler: 'Each download maximum 1,000 sku',
  uploadMsg: {
    txt_1: 'Import quantity: Each download maximum 1,000 sku.',
    txt_2: 'Success: The SKU found with the conditions provided.',
    txt_3: 'Failure: The SKU found unavailable with the conditions provided.',
    txt_4: 'Invalid: The SKU found unavailable due to blank conditions.',
    txt_5: '*The info of selected condition in upload format is requisite.',
  },
};
